<template>
    <div class="register-page has-fixed-top">
        <main-menu></main-menu>
        <div class="columns extra-pad">
            <div class="column is-full-height is-hidden-mobile">art here</div>
            <div class="column is-three-fifths register-column">

                <h1 class="register-h1">Create Your Free Acount</h1>
                <p class="">
                    Once registered you can create and stage competitions like a true pro. Or
                </p>
                <p class="">
                    Existing Users: <router-link to="/login">Login Here</router-link>
                </p>
                <register-form />
            </div>
        </div>
    </div>
</template>

<script>
    import RegisterForm from "./RegisterForm.vue"
    import MainMenu from "../home/header/MainMenu.vue"

export default {
    name: "RegisterPage",
    components: { RegisterForm, MainMenu }
}
</script>

<style>
.register-h1 { font-size: 3rem; font-weight: 600; line-height: 1.25; margin-bottom: 2rem; }
.register-column { background: #ebebeb; }
.register-page .columns { margin-top: 0; }
.register-page { }
.register-page .columns.extra-pad .column { padding: 2rem 3rem; }

@media (min-width: 768px) {
    .register-page .columns.extra-pad .column {
        padding: 3rem 3rem;
    }
}
</style>
